const brand = sessionStorage.getItem('brand');
export const settings = {
  myAccount: 'Llogaria ime',
  yourProfileAndPasswordSecurity: 'Profili juaj dhe siguria e fjalëkalimit',
  detailsHeader: 'Detajet',
  passwordHeader: 'Fjalëkalimi',
  customAttributeHeader: 'Atributi i ndryshueshëm',
  tagsHeader: 'Etiketat',
  accessTokenHeader: 'Tokeni i hyrjes',
  thirdPartyIntegrationsHeader: 'Integrimet e palëve të treta',
  appTooltip: {
    TOOLTIP_DETAILS_HEADING: 'Përditësoni profilin tuaj të llogarisë',
    TOOLTIP_PASSWORD_HEADING: 'Ndryshoni fjalëkalimin tuaj',
    TOOLTIP_TAGS_HEADING: 'Menaxhoni etiketat tuaja',
    TOOLTIP_THIRD_PARTY_HEADING: 'Integrimet e palëve të treta',
    TOOLTIP_CHANGE_PASSWORD_TITLE: `Një fjalëkalim i sigurt ndihmon në mbrojtjen e llogarisë suaj ${brand}`,
    TOOLTIP_INTEGRATIONS: 'Integro',
    TOOLTIP_ADD_UPDATE_CUSTOM_ATTRIBUTE: 'Shtoni ose përditësoni atributet e ndryshueshme',
    TOOLTIP_CUSTOM_ATTRIBUTES: 'Menaxhoni atributet tuaja të ndryshueshme'
  },
  accessToken: {
    accessToken: 'Tokeni i hyrjes',
    generateYourAccessTokenForUsingPlatformAPIs: `Gjeneroni tokenin tuaj të hyrjes për përdorimin e API-ve të platformës`,
    generateApiToken: 'Gjenero Token API',
    revokeApiToken: 'Anulo Tokenin API',
    regenerateApiToken: 'Rigjenero Tokenin API',
    placeholders: {
      yourApiKey: 'Çelësi juaj i API-së',
    }
  },
  details: {
    name: 'Emri',
    emailId: 'ID e-mail ',
    yourPlan: 'Plan juaj',
    messagesPerMonth: 'mesazhe/muaj',
    daysOfStoragePlan: 'ditë plan stokazhi',
    conditionalFeatures: 'veçoritë kushtetuese',
    upgradeToEnterprisePlanToGetMore: 'Ndërro në planin Enterprise për të marrë më shumë',
    featuresAndStorageCapacity: 'veçoritë dhe kapaciteti i stokazhit',
    upgradePlan: 'Ndërro planin',
    submit: 'Dërgo',
    selectLanguage: 'Zgjidhni Gjuhën',
    baby: 'Bebi',
    king: 'Mbreti',
    conversationsperMonth: 'biseda/muaj',
    english: 'Anglisht',
    hindi: 'Hindi',
    german: 'Gjermanisht',
    french: 'Frëngjisht',
    portuguese: 'Portugalisht',
    spanish: 'Spanjisht',
    italian: 'Italianisht',
    russian: 'Rusisht',
    chatBotBrandName: 'Emri i markës së chatbot',
    placeholders: {
      john: 'John',
      email: 'Email',
      searchLanguage: 'Kërko Gjuhën',
      chatBotBrandName: 'Emri i markës së chatbot',
      brandWebsiteUrl: 'www.yourbrand.com',
      agencyName: 'Lookup Technologies',
      phoneNumber: '9876543210',
      agencySupportEmail: 'support@yourbrand.com',
      agencyContactPersonName: 'Kevin Peterson',
      agencyContactPersonEmailId: 'kevin@yourbrand.com'
    },
    appTooltip: {
      TOOLTIP_NAME: 'Vendos emrin tuaj të profilin',
      TOOLTIP_EMAIL_ADDRESS: 'Vendos adresën tuaj të emailit',
    },
    changeEmail: {
      changeLabel: 'Ndrysho',
      sendVerificationCodeModal: {
        changeEmail: 'Ndrysho Emailin',
        changeEmailDescription: 'Vendosni adresën tuaj të re të emailit që dëshironi të përdorni në të ardhmen',
        newEmailLabel: 'ID e re e Emailit',
        changeEmailPlaceholder: 'Vendosni email të ri',
        sendVerificationCode: 'Dërgo Kodin e Verifikimit'
      },
      verifyEmailModal: {
        verifyEmail: 'Verifikoni Emailin!',
        verifyDescription: 'Kemi dërguar kodin e verifikimit në emailin tuaj të regjistruar ekzistues.',
        checkSpam: 'Nuk keni marrë email? Kontrolloni dosjen tuaj spam',
        labelText: 'Vendosni kodin 4-shifror',
        submitText: 'Dërgo',
        resendText: 'Ridërgo Kodin'
      }
    },
    myAccountDetails: {
      brandDetails: 'Detajet e markës',
      brandName: 'Emri i markës',
      brandWebsiteUrl: 'URL i faqes së markës',
      brandLogo: 'Logo e markës',
      agencyDetails: 'Detajet e agjencisë',
      agencyName: 'Emri i agjencisë',
      agencyPhoneNumber: 'Numri i telefonit të agjencisë',
      agencyEmailId: 'ID e-mail e agjencisë',
      contactPersonDetails: 'Detajet e personit të kontaktit',
      contactName: 'Emri i kontaktit',
      phoneNumber: 'Numri i telefonit',
      contactEmailId: 'ID e-maili',
      updateDetails: 'Përditëso Detajet'
    },
  },
  customAttribute: {
    addAttribute: 'Shto atribut',
    discard: 'Hidh Poshtë',
    customAttribute: 'Atributet e ndryshueshme',
    checkOrAddCustomAttribute: 'Këtu mund të kontrolloni dhe shtoni atributet tuaja të ndryshueshme.',
    attributeKey: 'Çelësi i atributit',
    attributeName: 'Emri i atributit',
    bot: 'Boti',
    flow: 'Fluksi',
    loadMore: 'Ngarko më shumë',
    question: 'Pyetje',
    action: 'Veprim',
    search: 'Kërko',
    selectBot: 'Zgjidhni Botin',
    selectFlow: 'Zgjidhni Fluksin',
    selectQuestion: 'Zgjidhni Pyetjen',
    noDataFoundHeading: 'Nuk keni krijuar ende asnjë atribut',
    noDataFoundSubheading: 'Të gjitha atributet tuaja do të shfaqen këtu',
    deleteTitle: 'Fshi atributin',
    deleteDescription: 'A jeni të sigurtë që dëshironi të fshini këtë atribut?',
    deleteAttributes: 'Fshi atributet',
    areYouSureYouWantToDeleteThisAttributes: 'A jeni të sigurtë që dëshironi të fshini këto atributet?',
    editAttribute: 'Ndrysho atributin',
    headsUp: 'Kujdes',
    okay: 'Në rregull',
    dataAddedToLead:
      'Atributet e mapuara në API-të tuaja ose Fluksat e Botit nuk do të përditësohen. Ju lutemi përditësoni API-të ose Fluksat e Botit në përputhje me to.',
    placeholders: {
      enterAttributeKey: 'Vendos Çelësin e Atributit',
      enterAttributeName: 'Vendos Emrin e Atributit',
      selectBot: 'Zgjidhni Botin',
      selectFlow: 'Zgjidhni Fluksin',
      selectQuestion: 'Zgjidhni Pyetjen',
      search: 'Kërko sipas Emrit të Atributit',
    },
    appToolTip: {
      TOOLTIP_ATTRIBUTE_KEY: 'Vendos Çelësin e Atributit',
      TOOLTIP_ATTRIBUTE_NAME: 'Vendos Emrin e Atributit',
      TOOLTIP_SELECT_BOT: 'Zgjidhni Botin',
      TOOLTIP_SELECT_FLOW: 'Zgjidhni Fluksin',
      TOOLTIP_SELECT_QUESTION: 'Zgjidhni Pyetjen',

    }
  },
  password: {
    changePassword: 'Ndrysho Fjalëkalimin',
    aSecurePasswordHelpsProtectYour: 'Një fjalëkalim i sigurt ndihmon në mbrojtjen e llogarisë suaj ',
    account: ' Llogaria',
    currentPassword: 'Fjalëkalimi aktual',
    newPassword: 'Fjalëkalimi i ri',
    confirmPassword: 'Konfirmo fjalëkalimin',
    cancel: 'Anulo',
    updatePassword: 'Përditëso Fjalëkalimin',
    deleteAccount: 'Fshi Llogarinë',
    placeholders: {
      enterYourCurrentPassword: 'Vendos Fjalëkalimin Aktual Tuaj',
      enterYourNewPassword: 'Vendosni fjalëkalimin tuaj të ri',
      enterYourConfirmPassword: 'Vendosni fjalëkalimin tuaj të konfirmuar',
    },
    appTooltip: {
      TOOLTIP_CURRENT_PASSWORD: 'Vendos fjalëkalimin e vjetër',
      TOOLTIP_NEW_PASSWORD: 'Vendos fjalëkalimin e ri',
      TOOLTIP_CONFIRM_PASSWORD: 'Konfirmo fjalëkalimin tënd të ri',
      TOOLTIP_DELETE_ACCOUNT: `Fshi llogarinë tuaj aktuale të ${brand}`,
    }
  },
  tags: {
    manageTags: 'Menaxho Etiketat',
    createNewTags: 'Krijo Etiketa të Reja',
    createNewTagsSubText: 'Menaxhoni etiketat tuaja këtu për t’i përdorur për organizimin më të mirë të udhëheqësve, bisedave, grupeve etj',
    tagName: 'Emri i etiketës',
    updateTag: 'Përditëso Etiketën',
    createTag: 'Krijo Etiketë',
    discard: 'Hidh Poshtë',
    searchTag: 'Kërko etiketën sipas emrit',
    noTagFound: 'Nuk u gjet asnjë etiketë!',
    createATag: 'Krijo një etiketë',
    deleteTagModalSubText: 'A jeni të sigurtë që dëshironi të fshini këtë etiketë? Fshirja e kësaj etikete do të heqë këtë etiketë nga përdoruesit e caktuar gjithashtu!',
    deleteTagModalHeading: 'Fshi Etiketat',
    deleteOneTagModalHeading: 'Fshi Etiketën',
    actions: 'Veprimet',
    placeholders: {
      enterTag: 'Vendos Emrin e Etiketës',
    },
    appTooltip: {
      TOOLTIP_DELETE_TAGS: 'Fshi Etiketat',
      TOOLTIP_MANAGE_TAGS: 'Menaxho Etiketat Tuaja',
    }
  },
  thirdPartyIntegration: {
    list: {
        name: 'Emri',
        status: 'Statusi',
        action: 'Veprimi',
        messageBird: 'MessageBird',
        messageBirdForSendingMessagesAndEmails: 'MessageBird për Dërgimin e Mesazheve dhe Email-ave',
        notConnected: 'Nuk është i Lidhur',
        connected: 'Është i Lidhur',
        edit: 'Redakto',
        plivo: 'Plivo',
        plivoForSendingMessages: 'Plivo për Dërgimin e Mesazheve',
        connect: 'Lidhu',
        appTooltip: {
            nameOfAppOrCrm: 'Emri i Aplikacionit/CRM',
            statusAsConnectedOrNotConnected: 'Statusi si i lidhur / s’është i lidhur',
            clickToConnectAppOrCrm: 'Klikoni për të lidhur Aplikacionin/CRM',
        },
        upgradeModal: {
            oopsIntegrationsAreNotAvailableForBabyPlan: 'Ups! Integracionet nuk janë në dispozicion në planin Baby. Ju lutemi ndërtoni në planin King për integrime.',
        }
    },
    providers: {
        messageBird: {
            messageBird: 'MessageBird',
            integrateWithMessageBird: 'Integro me MessageBird',
            apiKey: 'Çelësi API',
            originator: 'Krijuesi',
            connect: 'Lidhu',
            disconnect: 'Shkatërro lidhjen',
            seeActivities: 'Shiko Aktivitetet',
            sms: 'SMS ',
            time: 'Koha',
            phoneNumber: 'Numri i telefonit',
            status: 'Statusi',
            botName: 'Emri i Botit',
            message: 'Mesazhi',
            error: 'Gabimi',
            placeholders: {
                apiKey: 'Çelësi API',
                messageBirdPhoneNumber: 'Numri i telefonit MessageBird',
            },
            noDataFound: {
                activities: 'Aktivitetet',
                noActivitiesFound: 'Nuk u gjetën asnjë aktivitet!',
            }
        },
        plivo: {
            plivo: 'Plivo',
            integrateWithPlivo: 'Integro me Plivo',
            authId: 'Auth ID',
            authToken: 'Tokeni i Autorizimit',
            yourPlivoPhoneNumber: 'Numri juaj i telefonit Plivo',
            connect: 'Lidhu',
            disconnect: 'Shkatërro lidhjen',
            seeActivities: 'Shiko Aktivitetet',
            sms: 'SMS',
            time: 'Koha',
            phoneNumber: 'Numri i telefonit',
            status: 'Statusi',
            botName: 'Emri i Botit',
            message: 'Mesazhi',
            error: 'Gabimi',
            noDataFound: {
                activities: 'Aktivitetet',
                noActivitiesFound: 'Nuk u gjetën asnjë aktivitet!',
            },
            placeholders: {
                authId: 'Auth ID',
                authToken: 'Tokeni i Autorizimit',
                yourPlivoPhoneNumber: 'Numri juaj i telefonit Plivo',
            }
        }
    }
}
};
